export default __webpack_public_path__ + "static/media/Bodyspray.de220be1.png";